module.exports = __webpack_public_path__ + "img/notaZZ.d660164a.svg";